import { faArrowDownToLine } from '@fortawesome/pro-regular-svg-icons/faArrowDownToLine';
import { Icon, toast } from '@kontentino/ui';
import { ActionContext, createAction } from 'actions';
import { Comment } from 'app/modules/comments/types';
import { CognitoTokenManager } from 'app/modules/auth/utils/cognitoTokenManager';
import i18n from 'app/utils/i18n';
import config from 'config';
import { UserPermission } from 'constants/userPermission';
import { PostDetail } from 'types/PostDetail';
import FilesUtil from 'utils/files';
import { createSearchFromParams } from 'utils/url';

export const downloadCommentAttachments = (context: ActionContext) =>
  createAction(
    {
      id: 'download-comment-attachments',
      label: () => i18n.t('downloadAllAttachments'),
      icon: <Icon icon={faArrowDownToLine} />,
      scopes: UserPermission.POST_MASS_CHANGE_POST_STATUS,
      perform: async ({
        id,
        postId,
      }: {
        id: Comment['id'];
        postId: PostDetail['id'];
      }) => {
        const toastId = 'download-comment-attachments';
        const searchParams = createSearchFromParams({
          comment_id: id,
        });

        const accountId = CognitoTokenManager.getSelectedAccountId();

        context.toast(i18n.t('preparingDownload'), 'default', {
          id: toastId,
          duration: Infinity,
        });

        try {
          await FilesUtil.downloadFromUrl(
            `${config.API_SERVICE_ENDPOINT}/posts/${postId}/downloadCommentAttachments${searchParams}`,
            {
              headers: {
                Authorization: `Bearer ${context.appStore.authToken}`,
                'x-http-jwt-token': context.appStore.authToken ?? '',
                ...(accountId && { 'X-Account-Id': String(accountId) }),
              },
            },
          );
          toast.dismiss(toastId);
        } catch {
          toast.dismiss(toastId);
          context.toast(i18n.t('downloadFailed'), 'error');
        }
      },
    },
    context,
  );
